import { useQuery } from '@apollo/client';
import { HeadingBanner } from 'anf-core-react';
import React from 'react';
import useTranslatedText from '../../hooks/useTranslatedText';
import { ERROR_MESSAGE, LOADING_MESSAGE } from '../Messages/Messages';
import SiteMapSections from './SiteMapSections';
import { GET_CATEGORIES, GET_SITEMAP_HELPFUL_LINKS } from './queries/index';
import { getTransformedHelpfulLinks } from './tools/siteMapUtils';

const SiteMapPage = () => {
  const { loading, error, data } = useQuery(GET_CATEGORIES);
  const {
    data: helpfulLinksData,
    loading: linksLoading,
    error: linksError,
  } = useQuery(GET_SITEMAP_HELPFUL_LINKS);

  const helpfulLinks = useTranslatedText('helpLinks', { fallback: 'Helpful Links' });
  const policies = useTranslatedText('policies', { fallback: 'Policies' });
  const aboutUs = useTranslatedText('aboutUs', { fallback: 'About Us' });
  const help = useTranslatedText('help', { fallback: 'Help' });

  if (loading || linksLoading) return LOADING_MESSAGE;
  if (error || linksError) return ERROR_MESSAGE;

  const transformedHelpfulLinks = getTransformedHelpfulLinks(helpfulLinksData, {
    helpfulLinks,
    policies,
    aboutUs,
    help,
  });

  const mergedCategoriesList = transformedHelpfulLinks
    ? [...data.categoriesList, transformedHelpfulLinks]
    : data.categoriesList;

  return (
    <main className="siteMap">
      <div className="sitemapSection">
        <HeadingBanner variant="boxed">
          <h1 className="h1" data-text-key={data.textFor.pageTitle.key}>
            {data.textFor.pageTitle.value}
          </h1>
        </HeadingBanner>
        <div>
          <ul className="allSiteMapList" data-testid="sitemap">
            <SiteMapSections categoriesList={mergedCategoriesList} />
          </ul>
        </div>
      </div>
    </main>
  );
};

export default SiteMapPage;
